import { FnAntModalWidth } from '../../blocks/FnAntModal/constants';
import { TPrintFile, TKsfDirectoryFileItem, TKsfDirectoryItem } from '../../../commonTypes/basic';
import { TFileList } from './types';

export const getModalSize = (length: number): FnAntModalWidth => {
  switch (length) {
    case 1:
      return FnAntModalWidth.Sm;
    case 2:
    case 3:
      return FnAntModalWidth.Lg;
    default:
      return FnAntModalWidth.Xl;
  }
};

const getFilesWithoutLabel = (files) => files.map((file) => ({ ...file, label: '' }));

export const getFilesColumn = (files: TPrintFile[], type: string, hasLabel?: boolean): TFileList[] => {
  return Array.isArray(files) && files.length
    ? [
        {
          type: type,
          data: hasLabel ? files : getFilesWithoutLabel(files)
        }
      ]
    : [];
};

/*export const getKsfDirectoryPrintList = (
  ksfDirectoryItems: TKsfDirectoryFileItem[],
  printerid = null
): TKsfDirectoryFileItem[] => {
  if (!Array.isArray(ksfDirectoryItems)) {
    return [];
  }
  window.console.log(printerid);
  ksfDirectoryItems.forEach(({ ksfDirectoryFiles, printer }) => {
    if (printerid) {
      if (printer.id === printerid) {
        ksfDirectoryFiles = ksfDirectoryFiles.filter(
          ({ categories, files }) =>
            (Array.isArray(categories) && categories.length) || (Array.isArray(files) && files.length)
        );
        return { ksfDirectoryFiles, printer };
      }
    } else {
      ksfDirectoryFiles = ksfDirectoryFiles.filter(
        ({ categories, files }) =>
          (Array.isArray(categories) && categories.length) || (Array.isArray(files) && files.length)
      );
      return { ksfDirectoryFiles, printer };
    }
  });
  return ksfDirectoryItems;
};*/

export const getKsfDirectoryList = (files: TKsfDirectoryItem[]): TKsfDirectoryItem[] => {
  return Array.isArray(files)
    ? files.filter(
        ({ categories, files }) =>
          (Array.isArray(categories) && categories.length) || (Array.isArray(files) && files.length)
      )
    : [];
};
